<template>
  <div class="home-content-page-v prediction-car-page">
    <div class="two-content">
      <div class="content-1-1 mii-table">
        <content-title :title="'每日订单（' + preDay + '）'"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>订单名称</th>
              <th v-for="th in ths">{{th.label}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
              <td :class="{'s-bak-td': index % 3 === 1}" style="width:8em;">{{'订单' + (start_index + index + 1)}}</td>
              <td v-for="th in ths" :class="{'s-bak-td': index % 3 === 1, 'td-station': th.label === '油库'}">
                <span>{{data[th.key]}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="content-1-page">
          <el-pagination small @size-change="handleSizeChange" @current-change="pageChange" :total="showData.length" :page-sizes="[3, 7, 20, 50]" :page-size="row_num" layout="sizes, prev, pager, next">
          </el-pagination>
        </div>
      </div>
      <div class="content-1-2 mii-table">
        <div class="table-tool">
          <a href="javascript:;">
            <i class="iconfont icon-daochu" @click="clickOutPutFileIcon"></i>
          </a>
        </div>
        <content-title title="运送车辆"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th v-for="th in ths2">{{th.label}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
              <td v-for="th in ths2" :class="{'s-bak-td': index % 3 === 1}" style="position: relative;">
                <span>{{th.key === '在途时间' ? String(data[th.key]).slice(0, 4) : data[th.key]}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="content-2">
      <div class="chat-title">
        图表展示
      </div>
      <div class="chat-block">
        <div class="chat-content">
          <div class="chat-y">
            <div class="chat-y-line">
              <div class="y-top-note" style="text-align: right">
                <span class="">订单</span>
              </div>
              <div class="one-y" v-for="data in charData">{{data.name}}</div>
            </div>
            <div class="chat-y-data">
              <div class="data-one" v-for="data in charData">
                <div class="data-xian data-first-xian" :style="data.style1">
                  <div class="data-none">
                  </div>
                </div>
                <div class="data-xian">
                  <div class="data-num data-brn">
                    <div class="data-brn-note">
                      不容纳时间点<br>
                      {{data.brn_date}}
                    </div>
                  </div>
                </div>
                <div class="data-xian data-xian-sned">
                  <div class="data-num data-send">
                    <div class="data-brn-note">
                      不容纳时间点 - 断货时间点<br>
                      {{data.brn_date}} - {{data.dh_date}}
                    </div>
                  </div>
                </div>
                <div class="data-xian">
                  <div class="data-num data-dh">
                    <div class="data-brn-note">
                      断货时间点<br>
                      {{data.dh_date}}
                    </div>
                  </div>
                </div>
                <div class="data-xian" :style="data.style2">
                  <div class="data-none">
                  </div>
                </div>
              </div>
            </div>
            <div class="car-data">
              <div class="one-car-data" v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
                {{data['车牌号']}}
              </div>
            </div>
          </div>
          <div class="chat-x">
            <div class="one-x">
              {{dateList[0].slice(5)}}
            </div>
            <div class="one-x">
              {{dateList[1].slice(5)}}
            </div>
            <div class="one-x one-x-last">
              {{dateList[2].slice(5)}}
            </div>
            <div style="text-align: right;">
              <span class="y-top-note">时间</span>
            </div>
          </div>
        </div>
        <div class="chat-info">
          <div class="one-info">
            <div class="dian dian-1">
            </div>
            <span>可送货窗口</span>
          </div>
          <div class="one-info">
            <div class="dian dian-2">
            </div>
            <span>不容纳缓冲</span>
          </div>
          <div class="one-info">
            <div class="dian dian-3">
            </div>
            <span>断货缓冲</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import ContentTitle from '@/components_bit/ContentTitle'
import {
  outPutExcelFile,
  dateOperating,
  cmpDate
} from '@/cllib'

export default {
  data () {
    return {
      dateList: ['', '', ''],
      ths: [{
        key: '加油站名称',
        label: '加油站'
      },
      {
        key: '时间',
        label: '日期'
      },
      {
        key: '订单紧急程度',
        label: '订单类型'
      },
      {
        key: '油品名称',
        label: '油品'
      },
      {
        key: '罐号',
        label: '罐号'
      },
      {
        key: '空容',
        label: '空容'
      },
      {
        key: '油库名称',
        label: '油库'
      }],
      ths2: [{
        key: '车牌号',
        label: '车号'
      },
      {
        key: '车辆仓号',
        label: '车辆仓号'
      },
      {
        key: '仓容积',
        label: '仓容积'
      },
      {
        key: '不容纳时间',
        label: '不容纳时间点'
      },
      {
        key: '断货时间',
        label: '断货时间点'
      },
      {
        key: '空容',
        label: '空容'
      },
      {
        key: '预计发车时间',
        label: '预计发车时间'
      },
      {
        key: '在途时间',
        label: '在途时间'
      }],
      start_index: 0,
      row_num: 7
    }
  },
  components: {
    ContentTitle
  },
  methods: {
    clickOutPutFileIcon () {
      let datas = [{
        data: [],
        sheetName: 'data1'
      }]
      let row1 = ['加油站', '日期', '订单类型', '油品', '罐号', '空容', '车号', '所用车辆仓号', '仓容积', '不容纳时间点', '断货时间点', '预计发车时间', '在途时间']
      datas[0].data.push(row1)
      this.showData.forEach(function (item) {
        datas[0].data.push([item['加油站名称'], item['时间'], item['订单紧急程度'], item['油品名称'], item['罐号'], item['空容'], item['车牌号'], item['车辆仓号'], item['仓容积'], item['不容纳时间'], item['断货时间'], item['预计发车时间'], item['在途时间']])
      })
      outPutExcelFile(datas, '每日订单（' + this.preDay + '）.xls')
    },
    pageChange (currentPage) {
      this.start_index = (currentPage - 1) * this.row_num
    },
    handleSizeChange (pageSize) {
      this.row_num = pageSize
      this.start_index = 0
    }
  },
  computed: {
    preDay: {
      get () {
        let toDay = this.$store.getters.todayStr
        let tDay = dateOperating.computeDay({date: cmpDate(toDay), days: 1, format: 'yy-mm-dd'})
        let t2Day = dateOperating.computeDay({date: cmpDate(toDay), days: 2, format: 'yy-mm-dd'})
        this.dateList = [toDay, tDay, t2Day]
        return toDay
      }
    },
    showData: {
      get () {
        return this.$store.getters.orderGas
      }
    },
    charData: {
      get () {
        let data = []
        let vm = this
        let startDate = cmpDate(this.dateList[0] + ' 00:00')
        let maxDate = cmpDate(this.dateList[2] + ' 23:59')
        this.showData.slice(vm.start_index, vm.start_index + vm.row_num).forEach(function (item, index) {
          let oneData = {
            name: '订单' + (vm.start_index + index + 1),
            style1: {
              width: 0
            },
            style2: {
              width: 0
            },
            dh_date: item['断货时间'],
            brn_date: item['不容纳时间']
          }
          let endDate = item['不容纳时间'] ? cmpDate(item['不容纳时间'].length > 13 ? item['不容纳时间'] : (vm.dateList[0].slice(0, 5) + item['不容纳时间'])) : null
          let endDate2 = item['断货时间'] ? cmpDate(item['断货时间'].length > 13 ? item['断货时间'] : (vm.dateList[0].slice(0, 5) + item['断货时间'])) : null
          oneData.style1.width = item['不容纳时间'] ? (((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 72 * 100).toFixed(2) + '%') : '50%'
          oneData.style2.width = item['断货时间'] ? (((maxDate.getTime() - endDate2.getTime()) / 1000 / 60 / 60 / 72 * 100).toFixed(2) + '%') : '50%'
          data.push(oneData)
        })
        return data
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.flowStatus < 40) {
      next({name: 'single.single'})
    } else {
      store.dispatch('assignCarOrder')
      next()
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.td-station {
  position: relative;
}
.td-station:hover {
  .show-select {
    display: flex !important;
    z-index: 1000;
  }
}
.table-tool {
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  i {
    font-size: 1.3rem;
    margin-left: 1rem;
    color: #fff;
  }
}
.content-1-page {
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0.5em 0;
}
.two-content {
  width: 100%;
  display: flex;
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
}
.show-search {
  display: flex !important;
  z-index: 1000;
}
.select-cars-search {
  display: flex;
  padding: 0.3em 1em 0;
  border-bottom: 1px solid #fff;
  a {
    text-align: center;
    margin-left: 1em;
    margin-top: 0.3em;
    width: 1.2em;
    height: 1.2em;
    font-size: 1.5em;
    line-height: 1.2em;
    color: #081633;
    font-weight: 600;
    background: #fff;
    border-radius: 100%;
  }
}
.icon-change {
  color: #081633;
  padding-left: 0.2em;
}
.cars-infos-div {
  max-height: 20em;
  overflow: auto;
}
.cars-infos {
  color: #fff;
  display: flex;
  div {
    text-align: center;
    flex: 1;
  }
}
.cars-infos-th {
  color: #fff;
  display: flex;
  div {
    text-align: center;
    flex: 1;
  }
}
.cars-infos:hover {
  background-color: #081633;
}
.select-cars {
  position: absolute;
  top: 100%;
  width: 40em;
  display: none;
  color: #fff;
  z-index: 100;
  line-height: 2.5em;
  flex-direction:column;
  background-color: #012e53;
  border-radius: 0.3em;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
}
.car-data-id {
  position: relative;
  width: 7em;
}
.data-num:hover {
  .data-brn-note {
    display:block;
  }
}
.data-brn-note {
  position: relative;
  top: -3em;
  word-break:keep-all;
  white-space:nowrap; 
  height: 3em;
  display: none;
}
.car-data {
  display: flex;
  margin-top: 1.5em;
  flex-direction:column;
  width: 5em;
}
.one-car-data {
  width: 9em;
  position: relative;
  flex:1;
  display: flex;
  justify-content:center;
  align-items: center;
}

.data-xian-sned {
  flex: 1;
}
.data-none {
  flex:1;
  height: 1px;
  background-color: #999;
}
.data-num {
  width: 1.2em;
  flex: 1;
  height: 1em;
}
.data-send {
  background-color: #00ccff;
}
.data-brn {
  position: relative;
  background-color: #012e53;
}
.data-dh {
  background-color: #6b59cf;
}
.data-xian {
  display: flex;
  height: 100%;
  justify-content:center;
  align-items: center;
}
.y-top-note {
  height: 1.5em;
  width: 4em;
}
.chat-y-data {
  flex: 1;
  display: flex;
  flex-direction:column;
  margin: 1.5em 2em 0 0;
}
.chat-x {
  font-size: 0.88em;
  color: #081633;
  display: flex;
  margin-left: 3.45em;
  margin-right: 5em;
}
.one-x {
  text-align: center;
  flex: 1;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
}
.one-x-last {
  border-right: 0px solid #999;
}
.one-y {
  border-right: 1px solid #999;
  height: 7em;
  display: flex;
  justify-content:center;
  align-items: center;
}
.chat-y-line {
  width: 3.5em;
  font-size: 0.88em;
  color: #081633;
  display: flex;
  flex-direction:column;
}
.data-one {
  flex: 1;
  display: flex;
}
.chat-y-data {
  display: flex;
  flex: 1;
  flex-direction:column;
}
.chat-y {
  display: flex;
  width: 100%;
}
.chat-info {
  margin-bottom: 2.7em;
  margin-left: 2.7em;
  display: flex;
  flex-direction:column-reverse;
}
.dian-1 {
  background-color: #00ccff;
}
.dian-2 {
  background-color: #012e53;
}
.dian-3 {
  background-color: #6b59cf;
}
.dian {
  width: 0.5em;
  height: 0.5em;
  margin-right: 1em;
}
.one-info {
  color: #081633;
  font-size: 0.88em;
  height: 2em;
  display: flex;
  align-items: center;
}
.chat-block {
  display: flex;
  width: 85%;
}
.chat-content {
  display: flex;
  flex: 1;
  flex-direction:column;
  padding: 2em;
}
.chat-title {
  color: #0b5591;
  line-height: 1;
  padding-left: 0.5em;
  font-size: 0.94em;
  border-left: 4px solid #0b5591;
}
.i-zhuan {
  transform: rotate(180deg);
}
.zhuang-span {
  transition: 1s;
}
.btn-top-jiao {
  width: 0;
  height: 0;
  border-bottom: 0.81em solid @bak-color-2;;
  border-left: 1.7em solid transparent;
}
.btn-bottom-jiao {
  width: 0;
  height: 0;
  border-top: 0.81em solid @bak-color-2;
  border-right: 1.7em solid transparent;
}
.content-2 {
  padding: 1.88em 2.7em 4.8em;
  display: flex;
  flex-direction:column;
  background: #fff;
  border-radius: 0.5em;
  border-top: 2px dashed #bbb;
}
.content-1-table-2 {
  flex: 1;
  background:#fff;
  margin-left: 0.7em;
  display: flex;
  flex-direction:column;
}
.content-1 {
  background: #fff;
  display: flex;
  flex-direction:column;
}
.content-1-1 {
  background:#fff;
  width: 52%;
  margin-right: 1em;
}
.content-1-2 {
  background:#fff;
  flex: 1;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table-2 {
  background-color: @bak-color-td-1;
}
.pagination-table {
  text-align: right;
  margin-right: 0.5em;
}
.mii-table {
  .content-shadow;
  .content-top-radius;
  display: flex;
  position: relative;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .data-td {
    width: 10%;
  }
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
      height: 2em;
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    td {
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis; 
      height: 2.5em;
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      color: @bak-color-1;
    }
  }
}
</style>

<style lang="less">
.prediction-car-page .two-content .el-select .el-input .el-input__icon {
  background: rgba(0,0,0,0)
}
</style>



// WEBPACK FOOTER //
// prediction_station.vue?ba3cd278